import { IServiceRequestInitial } from '../../../models/service-request';
import { FieldValidation, validate } from '../../../validation/validation';
import * as Validators from '../../../validation/validators';
import { US } from '../../common/constants';
import { flattenObject } from '../../e-store/product-details/validation';

export class ServiceRequestFormErrors {
    contactName? = '';
    contactPhone? = '';
    poNumber? = '';
    Street1? = '';
    City? = '';
    State? = '';
    PostalCode? = '';
}

const contactNameValidation = new FieldValidation(
    'contactName',
    'Contact Name',
    [Validators.required()]
);

const poNumberValidation = new FieldValidation('poNumber', 'P O Number', [
    Validators.required(),
]);

const contactPhoneValidation = new FieldValidation(
    'contactPhone',
    'Phone Number',
    [Validators.isPhone(), Validators.required()]
);

const street1rValidation = new FieldValidation('Street1', 'Address', [
    Validators.required(),
]);

const cityValidation = new FieldValidation('City', 'City', [
    Validators.required(),
]);

const stateValidation = new FieldValidation('State', 'State/Province', [
    Validators.required(),
]);

const postalCodeValidation = new FieldValidation('PostalCode', 'Postal Code', [
    Validators.required(),
]);

const isValid = (serviceRequest: IServiceRequestInitial, country: string) => {
    const flattenedServiceRequest = flattenObject(serviceRequest);
    const fieldValidations: FieldValidation[] = [
        contactNameValidation,
        contactPhoneValidation,
    ];

    if (serviceRequest.shipTo.PoRequiredTypes && country === US) {
        fieldValidations.push(poNumberValidation);
    }

    if (serviceRequest.shipTo.FullAccountNumber === 'Other ...') {
        fieldValidations.push(street1rValidation);
        fieldValidations.push(cityValidation);
        fieldValidations.push(stateValidation);
        fieldValidations.push(postalCodeValidation);
    }

    const errors: ServiceRequestFormErrors = validate(
        flattenedServiceRequest,
        fieldValidations
    );

    return errors;
};

export default isValid;
